<span>
  <img src="./assets/images/copy.svg"  matTooltip="{{tooltipText}}" [cdkCopyToClipboard]="elementToCopy"
    (click)="onCopy(); $event.stopPropagation()" alt="">
</span>
